import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StepperContext } from "../../../stepper/context/StepperContext";
import "../../../styles/w7_formStyle.css";
import W7Page from "./W7Page";

export const Heade_w7 = ({
  option,
  setFormValues,
  showName,
  showSurname,
  showDob,
  showAddress1,
  showAddress2,
  showMiddleName,
  showNoAddressLine,
  showNoAddressLine2,
  getLoading,
  handleUpdate,
}: {
  option?: any;
  setFormValues?: (values: any) => void;
  showName?: boolean;
  showSurname?: boolean;
  showDob?: boolean;
  showAddress1?: boolean;
  showAddress2?: boolean;
  showMiddleName?: boolean;
  showNoAddressLine?: boolean;
  showNoAddressLine2?: boolean;
  getLoading?: boolean;
  handleUpdate?: () => void;
}) => {
  const stepperState = useContext(StepperContext);
  const defaultValues = {
    applicationType: {
      apply: false,
      renew: false,
    },
    reason: "",
    treatyCountry: "",
    treatyArticle: "",
    checkboxes: {
      a: false,
      b: false,
      c: false,
      d: false,
      e: false,
      f: false,
      g: false,
      isCompany: false,
    },
    additionalInfo: {
      dependentRelationship: "",
      spouseName: "",
      spouseSSN: "",
      otherReason: "",
    },
  };
  const { status } = useSelector((store: any) => store.itin);

  const [formValues, setFormValuesData] = useState(
    stepperState.data.get(stepperState.currentStepIdx) || defaultValues,
  );

  useEffect(() => {
    if (option && JSON.stringify(option) !== JSON.stringify(formValues)) {
      setFormValuesData((prevValues: any) => ({
        ...prevValues,
        ...option,
        name: prevValues.first_name || prevValues.first_name,
        applicationType: {
          ...prevValues.applicationType,
          ...option.applicationType,
        },

        reason: option.reason || prevValues.reason,
        treatyCountry: option.treatyCountry || prevValues.treatyCountry,
        treatyArticle: option.treatyArticle || prevValues.treatyArticle,
        checkboxes: {
          ...prevValues.checkboxes,
          ...option.checkboxes,
        },
        additionalInfo: {
          ...prevValues.additionalInfo,
          ...option.additionalInfo,
        },
      }));
    }
  }, [option]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValuesData((prev: any) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setFormValuesData((prev: any) => ({
      ...prev,
      checkboxes: { ...prev.checkboxes, [name]: checked },
      applicationType: {
        ...prev.applicationType,
        [name]: checked,
      },
    }));
  };

  return (
    /*
      The form body is now W7Page — an exact replica of the official
      Rev. August 2019 layout, built from coordinates measured out of fw7.pdf.
      Heade_w7 keeps its old signature and state plumbing so Step3.tsx and
      W7_form.tsx are untouched, and W7Page writes back through the same field
      names the previous table used, so the payload Step3 builds from
      w7FormValues is unchanged.
    */
    <div id="pdf-content" className="fixed-width-container w7-screen">
      <W7Page
        value={formValues}
        onChange={(patch: any) =>
          setFormValuesData((prev: any) => {
            const next = { ...prev, ...patch };
            setFormValues?.(next);
            return next;
          })
        }
        disabled={status === "loading"}
      />
    </div>
  );
};

export default Heade_w7;
